import axios from 'axios';
import { AnalysisData, AnalyzeRequest } from '../types';

// API 配置：后端地址
// 生产环境使用 BASE_URL（虚拟目录路径），开发环境使用 localhost
const getBackendUrl = () => {
  let url: string;
  if (import.meta.env.VITE_BACKEND_URL) {
    url = import.meta.env.VITE_BACKEND_URL;
  } else if (import.meta.env.PROD) {
    // 生产环境：使用 Vite 的 base 路径
    url = import.meta.env.BASE_URL;
  } else {
    // 开发环境：使用本地后端
    url = 'http://localhost:8001';
  }
  // 确保以斜杠结尾
  return url.endsWith('/') ? url : url + '/';
};

const BACKEND_URL = getBackendUrl();

const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 分析文本（通过后端代理调用 zxNLP）
export async function analyzeText(request: AnalyzeRequest): Promise<AnalysisData> {
  const response = await api.post('api/nlp/analyze', {
    text: request.text,
    doc_id: request.doc_id || 'practice_doc',
    translator: request.translator || 'none',  // 默认禁用翻译
    model: request.model || 'en_core_web_trf',
    remove_chinese: true,
  });
  return response.data;
}

// 健康检查
export async function checkHealth(): Promise<boolean> {
  try {
    const response = await api.get('api/health');
    return response.data?.status === 'ok';
  } catch {
    return false;
  }
}

// 检查 zxNLP 服务健康状态
export async function checkNLPHealth(): Promise<boolean> {
  try {
    const response = await api.get('api/nlp/health');
    return response.data?.healthy === true;
  } catch {
    return false;
  }
}

export default api;
